export default __webpack_public_path__ + "static/media/Software.eb014bd6.svg";